"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.redeemAuthenticationCodeCommand = void 0;var _storage = require("../storage");
var _const = require("../const");
var _command = require("./command");


var _logging = require("../utils/logging");

/**
 * Exchanges an authentication code for authentication tokens
 * @param id - command ID
 * @param config
 * @param state
 * @param code - authentication code
 * @param encodedClientState - encoded client state - will be returned in response
 */
const redeemAuthenticationCodeCommand = (id, config, state, code, encodedClientState) => {
  const codeVerifier = (0, _storage.getLocalStorageWithExpiration)(_const.PKCE_STORAGE_KEY);
  _logging.Logger.info('redeeming code', code);
  _logging.Logger.debug("Code Verifier", codeVerifier);
  config.authenticationFrame.contentWindow.postMessage(
    new _command.Command(config.clientType, _command.Command.Commands.redeemCode, {
      id,
      code,
      codeVerifier,
      redirectUri: config.redirectUri,
      clientType: config.clientType,
      clientState: encodedClientState
    }),
    '*'
  );
  (0, _storage.removeFromLocalStorage)(_const.PKCE_STORAGE_KEY);
};exports.redeemAuthenticationCodeCommand = redeemAuthenticationCodeCommand;